/* eslint-disable import/no-extraneous-dependencies */

import Admin from 'hive-admin';

import getFilterWithCol from '../../../helpers/getFilterWithCol';

const isNotReveal = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'type',
  '!==',
  'REVEAL',
]);

const isRevealTypeInstant = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'reveal_type',
  '===',
  'INSTANT',
]);

const isRevealEaseTypeLinear = Admin.compileFromLibrary([
  'condition.testFieldValue',
  'reveal_easeType',
  (value) => ['AUTO', 'LINEAR'].includes(value),
]);

export default [
  ...[
    getFilterWithCol(['FieldSelect', {
      label: null,
      name: 'reveal_type',
      prefix: 'Type:',
      initialValue: 'FADE',
      block: true,
      // eslint-disable-next-line max-len
      choices: ['Fade', 'Up', 'Down', 'Left', 'Right', 'Scale', 'Instant'].map(label => ({
        value: label.toUpperCase(),
        label,
      })),
    }], 24),
    getFilterWithCol(['FieldText', {
      label: null,
      prefix: 'Duration:',
      name: 'reveal_duration',
      skip: [isRevealTypeInstant],
    }], 12),
    getFilterWithCol(['FieldText', {
      label: null,
      prefix: 'Delay:',
      name: 'reveal_delay',
      skip: [isRevealTypeInstant],
    }], 12),
    getFilterWithCol(['FieldSelect', {
      label: null,
      name: 'reveal_easeType',
      prefix: 'Easing:',
      initialValue: 'AUTO',
      skip: [isRevealTypeInstant],
      choices: [{
        label: 'Auto',
        value: 'AUTO',
      }, {
        label: 'Linear',
        value: 'LINEAR',
      }, {
        label: 'Ease In',
        value: 'EASE_IN',
      }, {
        label: 'Ease Out',
        value: 'EASE_OUT',
      }, {
        label: 'Ease',
        value: 'EASE_IN_OUT',
      }],
      block: true,
    }], 24),
    getFilterWithCol(['FieldSelect', {
      label: null,
      prefix: 'Easing Function:',
      name: 'reveal_easeFunction',
      initialValue: 'QUINT',
      choices: [
        'SINE',
        'QUAD',
        'CUBIC',
        'QUART',
        'QUINT',
        'EXPO',
        'CIRC',
        'BACK',
      ].map(value => ({
        value,
        label: `${value[0]}${value.slice(1).toLowerCase()}`,
      })),
      skip: [isRevealTypeInstant, isRevealEaseTypeLinear],
    }], 24),
  ].map(([fieldType, fieldConfig]) => Admin.compileFromLibrary([
    fieldType,
    {
      ...fieldConfig,
      preSkip: [isNotReveal, ...(fieldConfig.preSkip || [])],
    },
  ])),
];
